var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" This will auto display all image assets in partners folder ")])
}
var staticRenderFns = []

export { render, staticRenderFns }